<template>
  <modal :id="modalId">

    <template v-slot:header>
      <i class="fa fa-ban modal-icon"></i>
      <h4 class="modal-title">{{ title }}</h4>
    </template>

    <form :id="formId" :action="action" method="POST">

      <h3 class="mb-3">Are you sure you would like to reject the claim?</h3>

      <div class="form-group" :class="{'has-error': !reason}">
        <textarea name="claim_rejection_reason" class="form-control" rows="5"
                  placeholder="Enter the reason why you are rejecting this claim..." v-model="reason"></textarea>
      </div>

      <input type="hidden" name="_method" value="PATCH">
      <input type="hidden" name="_token" :value="$csrf_token">
    </form>

    <template #footer>
      <button type="button" class="btn btn-default" @click="hideModal">
        <i class="fa fa-fw fa-close"></i> Cancel
      </button>
      <button type="submit" name="button_reject" class="btn btn-danger" :disabled="!reason" :form="formId">
        <i class="fa fa-fw fa-save"></i> Reject
      </button>
    </template>

  </modal>
</template>

<script>
import HasModal from "./../mixins/HasModal";
export default {
  mixins: [HasModal],

  props: {

    // Modal dialog id.
    modalId: {
      required: false,
      type: String,
      default: 'rejectClaimModal'
    },

    // Form action URL.
    action: {
      type: String,
      default: ""
    },

    // Form title.
    title: {
      type: String,
      default: ""
    },

  },

  /**
   * Variables (models).
   */
  data() {
    return {
      reason: '',
    }
  },

  /**
   * Computed values
   */
  computed: {

    formId() {
      return this.modalId + "-form"
    }

  }
}
</script>
